"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseContextValue = void 0;
const useContextValue_1 = require("./useContextValue");
function createUseContextValue(context, defaultValue) {
    return () => (0, useContextValue_1.useContextValue)(context, defaultValue);
}
exports.createUseContextValue = createUseContextValue;
